import setWinnerSelect from "./setWinnerSelect.container";

export default setWinnerSelect;
